import {Plugins} from '@packages/systems/wfdl';
import {CollaboratorsList} from './CollaboratorsList';

export const plugin = Plugins.PrivilegedPlugin({
  dataTypes: {
    CollaboratorsList,
  },
});
